import { Icon } from '@eventbrite/marmalade';
import React from 'react';
import styles from './DiscountSignal.module.scss';
import { DiscountSignalIcon } from './DiscountSignalIcon';

export const DiscountSignal: React.FC<{
    children: React.ReactNode;
    className?: string;
}> = ({ children, className }) => {
    if (!children) {
        return null;
    }

    const discountSignalClassName = [styles.discount];

    if (className) {
        discountSignalClassName.push(className);
    }

    return (
        <div className={discountSignalClassName.join(' ')}>
            <Icon size="xsmall">
                <DiscountSignalIcon />
            </Icon>
            <span>{children}</span>
        </div>
    );
};
